import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaShoppingCart, FaShippingFast, FaTag } from 'react-icons/fa';

const ProductCard = ({ product, handleAddToWishlist, handleAddToCart }) => {
  const handleWishlistClick = (event) => {
    event.preventDefault();
    handleAddToWishlist(product);
  };

  const isOutOfStock = product.stock === 0;

  return (
    <div
      className={`group rounded-lg border p-3 sm:p-4 shadow-md transition-all hover:shadow-lg ${
        isOutOfStock ? 'bg-gray-200 dark:bg-gray-700 opacity-70' : 'bg-white dark:bg-gray-800'
      } dark:border-gray-700`}
    >
      <Link to={`/product/${product.id}`} className="block relative overflow-hidden rounded-lg">
        <img
          src={product.imageURI}
          alt={product.name}
          className="w-full h-40 sm:h-64 object-cover rounded-t-lg transition-transform duration-300 transform group-hover:scale-105"
        />
        {product.discount > 0 && (
          <span className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-lg shadow-lg">
            {product.discount}% Off
          </span>
        )}
        <div className="absolute top-2 right-2 flex space-x-1 opacity-0 transition-opacity group-hover:opacity-100">
          <button
            onClick={handleWishlistClick}
            className="p-1 bg-white rounded-full shadow-md text-red-600 hover:bg-red-100 transition-colors"
          >
            <FaHeart />
          </button>
        </div>
      </Link>
      <div className="p-2 sm:p-4">
        <h3 className="text-sm sm:text-lg font-semibold text-gray-900 dark:text-white group-hover:text-blue-600 transition-colors">
          {product.name}
        </h3>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mt-2">
          <div>
            {product.discount > 0 ? (
              <p className="text-md sm:text-xl font-bold text-red-600">
                ${product.final_price}
                <span className="text-gray-500 dark:text-gray-400 line-through ml-2 text-xs sm:text-base">
                  ${product.price}
                </span>
              </p>
            ) : (
              <p className="text-md sm:text-xl font-bold text-gray-900 dark:text-white">
                ${product.final_price}
              </p>
            )}
          </div>
        </div>

        <button
          onClick={() => handleAddToCart(product)}
          className={`w-full mt-4 px-3 py-2 sm:px-6 sm:py-3 text-xs sm:text-base font-bold rounded-lg shadow transition ${
            isOutOfStock
              ? 'bg-gray-400 cursor-not-allowed text-gray-700 dark:text-gray-500'
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
          disabled={isOutOfStock}
        >
          <FaShoppingCart className="inline-block mr-2" />
          {isOutOfStock ? 'Out of Stock' : 'Add to Cart'}
        </button>

        <div className="flex flex-wrap space-x-2 sm:space-x-4 mt-4 text-xs sm:text-sm text-gray-600 dark:text-gray-400">
          <div className="flex items-center">
            <FaShippingFast className="mr-1" />
            Fast Delivery
          </div>
          <div className="flex items-center">
            <FaTag className="mr-1" />
            Best Price
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
